import React, { Component } from 'react';
import ViewHeader from '../../../components/ViewHeader';
import ModuleContainer from '../../../components/ModuleContainer';
import { FaPencilAlt, FaRegWindowClose, FaArrowLeft, FaTrashAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormTemplate from '../../../components/FormTemplate';
import { Row, Col } from 'react-bootstrap';
import { isNullOrUndefined } from 'util';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { MSG_CONFIRM_CHANGES, MSG_DEFAULT_ERROR, SAVE_CHANGES, DELETE_POPUP, DELETE_MESSAGE } from '../../../../utils/messages';
import { withRouter } from 'react-router-dom';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { VIDEO_MANAGEMENT, VIEW_VIDEO_DETAILS } from '../routes';
import {
    MODE_EDIT, MODE_ADD, MODE_VIEW, SUCCESS, NOTIF_ERROR, NOTIF_SUCCESS, DATE_TIME_FORMAT, ERROR, VIDEO_DETAILS, NO, SECONDARY, YES, SUCCESS_BUTTON, DANGER,
    CANCEL, SAVE, BACK, PRIMARY, UPDATE, DELETE
} from '../../../../utils/constants';
import { announcementSelectors, announcementOperations } from '../state';
import { SideNotification } from '../../../../utils/common';
import moment from 'moment';
import debounce from 'lodash.debounce';


class ViewVideoDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            videoId: 0,
            mode: MODE_ADD,
            showSaveModal: false,
            showDeleteModal: false,
            popupDetails: [],
            editorState: EditorState.createEmpty(),
            prevEditorState: EditorState.createEmpty(),
            initialFormValues: null,
            hasSubmit: false
        }

        //Required to make submission possible on external button
        this.submitForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
        this.deletePopup = debounce(this.deletePopup.bind(this), 500);
    }

    componentDidMount() {
        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setState({ mode: MODE_ADD })
        } else {
            let type = isNullOrUndefined(this.props.location.state) ? MODE_VIEW : this.props.location.state.type;

            this.setState({ videoId: id, mode: type }, () => {
                this.props.getVideoById(this.state.videoId)
                    .then((response) => {
                        if (ERROR === response.status) {
                            SideNotification(NOTIF_ERROR, response.message)
                        } else {
                            let popup = response.data[0];

                            this.setState({
                                initialFormValues: { VideoModel: popup },
                            })
                        }
                    })
                    .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
            })
        }
    }

    updateMode = (mode) => {
        if (null !== this.state.initialStoreDetails) {
            this.setState({ mode });
        }
    }

    onCancelClick = () => {
        if (!isNullOrUndefined(this.state.initialFormValues)) {
            this.form.resetForm(this.state.initialFormValues);
        }
        this.setState(prevState => ({
            editorState: prevState.prevEditorState,
            mode: MODE_VIEW
        }))
    }

    renderRightButtons = () => {
        switch (this.state.mode) {
            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: () => this.props.history.push(VIDEO_MANAGEMENT) },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            case MODE_EDIT: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            default: {
                return [
                    { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(VIDEO_MANAGEMENT) },
                    { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                    { variant: DANGER, label: DELETE, icon: FaTrashAlt, onClick: this.toggleDelete }
                ]
            }
        }
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    onSubmitClick = () => {
        this.setState({ hasSubmit: true })
        this.form.submitForm();
        if (MODE_ADD === this.state.mode) {
            this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
        }
    }

    resetAdsForm = () => {
        this.form.resetForm();
        this.setState({ editorState: EditorState.createEmpty(), imageFile: null, imageFileUrl: null, imageError: false })
    }

    handleSubmit = (values) => {
        // let value = values.VideoModel.message

        this.setState({

            videoDetails: values,

        }, () => this.toggleSave());
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    toggleDelete = () => {
        this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal }))
    }

    returnToList = () => {
        this.props.history.push(VIDEO_MANAGEMENT);
    }

    saveChanges = () => {
        let values = this.state.videoDetails;
        
        values.VideoModel.isLive = values.VideoModel.isLive ? `1` : `0`;
        values.VideoModel.isAllStarGame = values.VideoModel.isAllStarGame ? `1` : `0`;
        
        if (MODE_EDIT === this.state.mode) {
            values.VideoModel.videoId = this.state.videoId;

            this.props.updateGameVideo(values.VideoModel)
                .then(result => {
                    if (SUCCESS === result.status) {
                        this.setState({ mode: MODE_VIEW, showSaveModal: false, initialFormValues: { VideoModel: values } })
                        SideNotification(NOTIF_SUCCESS, result.message);
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.insertGameVideo(values.VideoModel)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.setState({ ConfirmationModal: !this.state.ConfirmationModal })
                        this.props.history.push(VIDEO_MANAGEMENT)
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }

    deletePopup = () => {
        this.props.deleteVideo(this.state.videoId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.returnToList()
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    updateEditorState = (editorState) => {
        this.setState({ editorState })
    }

    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    title={VIDEO_DETAILS}
                    rightButtons={this.renderRightButtons()}
                />
                <Row style={{ paddingTop: '30px' }}>
                    <Col md={6} className="flex-align">
                        <FormTemplate
                            hasSubmit={this.state.hasSubmit}
                            editMode={MODE_ADD !== this.state.mode}
                            readOnly={MODE_VIEW === this.state.mode}
                            initialValues={this.state.initialFormValues}
                            bindSubmitFormik={this.bindSubmitFormik}
                            formInputs={this.props.videoForm}
                            validate={announcementSelectors.validatePopupForm}
                            updateFormRef={this.updateFormRef}
                            handleSubmit={this.handleSubmit}
                            editorState={this.state.editorState}
                            updateEditorState={this.updateEditorState}
                        />
                    </Col>
                </Row>
                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_POPUP}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deletePopup, variant: DANGER }
                    ]}
                />

            </ModuleContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        videoForm: state.announcements.videoForm
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getVideoById: announcementOperations.getVideoById,
        insertGameVideo: announcementOperations.insertGameVideo,
        updateGameVideo: announcementOperations.updateGameVideo,
        deleteVideo: announcementOperations.deleteVideo
    },
    dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewVideoDetails));